import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';

const WhyUs = () => {
  return (
    <div className="page">
      <section className="page-hero page-hero--red">
        <div className="container">
          <h1>Why We Focus on Practical Data & AI Education</h1>
        </div>
      </section>

      <section className="page-content section">
        <div className="container">
          <div className="content-wrapper">
            <p className="lead-text">
              We believe learning should be aligned with industry needs. Our programs are built by practitioners who understand real-world challenges and help learners become job-ready through hands-on training and mentorship.
            </p>

            <div className="content-grid">
              <div className="content-card">
                <h2>Industry-Driven Curriculum</h2>
                <p>
                  Our courses are continuously updated based on what companies actually need. We don't teach outdated concepts—we focus on tools, techniques, and methodologies that are in demand right now.
                </p>
              </div>

              <div className="content-card">
                <h2>Practitioner-Led Learning</h2>
                <p>
                  Our mentors are working professionals who solve real data problems daily. They bring current industry insights, real case studies, and practical knowledge that you won't find in textbooks.
                </p>
              </div>

              <div className="content-card">
                <h2>Hands-On Approach</h2>
                <p>
                  Theory without practice is incomplete. Every concept is reinforced with hands-on exercises, real datasets, and projects that mirror actual industry scenarios.
                </p>
              </div>

              <div className="content-card">
                <h2>Career-Focused Outcomes</h2>
                <p>
                  We don't just teach—we prepare you for your career. From resume building to interview preparation, we provide comprehensive support to help you land your dream role.
                </p>
              </div>

              <div className="content-card">
                <h2>Small Batch Sizes</h2>
                <p>
                  Limited seats ensure that every learner gets individual attention. You're not just a number—you're part of a learning community where your growth matters.
                </p>
              </div>

              <div className="content-card">
                <h2>Real-World Projects</h2>
                <p>
                  Build a portfolio that showcases your skills. Our capstone projects are designed to demonstrate your ability to solve real business problems using data and AI.
                </p>
              </div>
            </div>

            <div className="cta-section">
              <h2>Ready to Start Your Journey?</h2>
              <p>Join our programs and experience the difference of practical, mentor-led learning.</p>
              <div className="cta-buttons">
                <Link to="/academy/apply" className="btn btn-primary btn-large">
                  Apply Now
                </Link>
                <Link to="/academy/contact" className="btn btn-secondary btn-large">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyUs;



